angular.module('impactx.rfxsupplier').component('ixRfxSupplierDecisionCriteria', {
        bindings: {
            priceQualityTradeOff: '<',
            comments: '<',
            isClosed: '<',
            trns: '<'
        },
        controller: 'RFXSupplierDecisionCriteriaCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-decision-criteria.html'
    }
);